import { render, staticRenderFns } from "./ghDynamicInvoke.vue?vue&type=template&id=5c3fb4a6&scoped=true&"
import script from "./ghDynamicInvoke.vue?vue&type=script&lang=js&"
export * from "./ghDynamicInvoke.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3fb4a6",
  null
  
)

export default component.exports